import type { AxiosResponse } from 'axios'
import api from '../utils/api'

export interface RoleSummary {
  roleName: string
  roleId: string
  roleType?: string
  modifiedBy?: string
  modifiedByUsername?: string
  modifiedOn?: string
}

/**
 * Current user's roles. When `baseDivisionId` is passed, the BE scopes each
 * scoped-Viewer role's `attributes` to the values that gate access to that
 * division (camelCase → `base_division_id` on the wire via the case-converter).
 */
const getCurrentUserRole = async (baseDivisionId?: string): Promise<AxiosResponse> => {
  return await api.get('/api/roles/current_user/', {
    params: baseDivisionId != null ? { baseDivisionId } : undefined
  })
}

const getRolesSummary = async (): Promise<AxiosResponse> => {
  return await api.get('/api/roles/summary/')
}

const getRoleData = async (roleId: string, params?: Record<string, any>): Promise<AxiosResponse> => {
  return await api.get(`/api/roles/${roleId}/users/`, {
    headers: {
      Accept: 'application/cdg'
    },
    params
  })
}

const deleteUserRole = async (userId: string, roleId: string): Promise<AxiosResponse> => {
  return await api.delete(`/api/users/${userId}/role/${roleId}`)
}

const getUsersForRole = async (roleName: string): Promise<AxiosResponse> => {
  return await api.get(`/api/roles/users/?role_name=${roleName}`)
}

const addUserToRole = async (userId: string, requestBody: Record<string, any>): Promise<AxiosResponse> => {
  return await api.post(`/api/users/${userId}/role/`, requestBody)
}

const getViewerFamilyRoles = async (): Promise<AxiosResponse<RoleSummary[]>> => {
  return await api.get('/api/roles/summary/?is_viewer=true')
}

const copyViewerRole = async (): Promise<AxiosResponse<RoleSummary>> => {
  return await api.post('/api/roles/copy_viewer/')
}

const deleteViewerCopy = async (roleId: string): Promise<AxiosResponse<{ message: string }>> => {
  return await api.delete(`/api/roles/copy_viewer/${roleId}/`)
}

export default {
  getCurrentUserRole,
  getRolesSummary,
  getRoleData,
  deleteUserRole,
  getUsersForRole,
  addUserToRole,
  getViewerFamilyRoles,
  copyViewerRole,
  deleteViewerCopy
}
